/** A copy of `items`, largest count first (ties keep their original order). */
export const largestFirst = <T extends { count: number }>(items: T[]): T[] => items
  .map((item, index) => ({ item, index }))
  .sort((a, b) => b.item.count - a.item.count || a.index - b.index)
  .map(({ item }) => item);

/**
 * Percentages of `counts` with one decimal that add up to exactly 100: tenths are rounded down and
 * the ones left over go to the largest remainders.
 */
export const sharesOf = (counts: number[]): number[] => {
  const sum = counts.reduce((a, b) => a + b, 0);
  if (!sum) {
    return counts.map(() => 0);
  }
  const tenths = counts.map(count => (1000 * count) / sum);
  const floors = tenths.map(Math.floor);
  let left = 1000 - floors.reduce((a, b) => a + b, 0);
  tenths
    .map((value, index) => ({ index, remainder: value - floors[index] }))
    .sort((a, b) => b.remainder - a.remainder)
    .forEach(({ index }) => {
      if (left > 0) {
        floors[index] += 1;
        left -= 1;
      }
    });
  return floors.map(value => value / 10);
};
